import { HelpCircle } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';

/**
 * Ícone de ajuda com a explicação de um campo. Abre ao passar o mouse e ao
 * tocar (no celular não há hover: o toque foca o botão e o Radix abre).
 * Para rótulo + campo juntos, há o FieldTip.
 */
export function Dica({ texto, rotulo = 'Ajuda' }: { texto: string; rotulo?: string }) {
  return (
    <Tooltip.Root delayDuration={150}>
      <Tooltip.Trigger asChild>
        <button
          type="button"
          className="inline-flex shrink-0 cursor-help rounded-full align-middle text-ha-muted outline-none transition hover:text-ha-subtle focus-visible:ring-2 focus-visible:ring-accent/40"
          aria-label={rotulo}
        >
          <HelpCircle className="h-[14px] w-[14px]" strokeWidth={1.65} aria-hidden />
        </button>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          className="z-50 max-w-xs border border-ha-border bg-ha-card2 px-3 py-2 text-xs leading-snug text-ha-subtle"
          sideOffset={4}
        >
          {texto}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
